import React, { useContext, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faXmark,
  faPlus,
  faPalette,
  faTrash,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { Popover, PopoverAnchor, PopoverContent, Tooltip } from "../../input";
import "./settings-color.scss";
import { GrigoraDashboardContext } from "../../dashboard/context";
import GlobalSketchPicker from "../../input/globalsketchpicker";
import slugify from "slugify";
import { INPUT_LIMITS } from "../../input-limits";

const RenderColor = ({
  color,
  onChange,
  onDelete,
  colorName,
  onColorNameChange,
  newAdded = false,
}) => {
  const [customColorName, setCustomColorName] = useState(colorName);
  const [showSketchPicker, setShowSketchPicker] = useState(false);
  if (color === undefined || color === null) {
    color = "";
  }

  return (
    <div className="wrapper">
      <Popover
        placement="left"
        open={showSketchPicker}
        onOpenChange={setShowSketchPicker}
      >
        <PopoverAnchor className="relative">
          <div
            className="w-[28px] h-[28px] rounded-full border"
            style={{
              backgroundColor: color ? color : "transparent",
              boxShadow: "inset 0 0 0 1px rgb(255 255 255 / 20%)",
            }}
            onClick={() => {
              setShowSketchPicker(true);
            }}
          ></div>
          <div
            onClick={() => onDelete()}
            className="cross-icon  cursor-pointer absolute right-[-8px] top-[-8px] flex items-center justify-center w-[16px] h-[16px] text-gray-500"
          >
            <FontAwesomeIcon
              className="text-gray-500"
              color="#000"
              icon={faXmark}
            />
          </div>
        </PopoverAnchor>
        <PopoverContent className="!bg-editor-light-main !z-[10010] !shadow-editor-floating-elements !rounded-[10px]">
          <div className="color-sketch-picker p-4 ">
            <div className="pb-2">
              <label className="">Color Name</label>
              <br />
              <input
                className="border-[1px] focus:outline-none"
                type="text"
                minLength={INPUT_LIMITS["custom-color-name"].minlength}
                maxLength={INPUT_LIMITS["custom-color-name"].maxlength}
                value={customColorName}
                onChange={(e) => {
                  setCustomColorName(
                    slugify(e.target.value, {
                      trim: false,
                      strict: true,
                      lower: true,
                    }),
                  );
                  onColorNameChange(
                    slugify(e.target.value, {
                      trim: false,
                      strict: true,
                      lower: true,
                    }),
                  );
                }}
              />
            </div>
            <GlobalSketchPicker
              hidePresets={false}
              value={color}
              onChange={onChange}
            />
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};

function SettingsColor() {
  const { project, setProjectData, setProjectColors, updateProjectColors } =
    useContext(GrigoraDashboardContext);

  const [newAdded, setNewAdded] = useState(false);

  const projectColors = project.colors;

  const changeColorName = (index, updated_name) => {
    var tempColors = projectColors
      ? [...(projectColors ? projectColors : [])]
      : [];
    tempColors[index].title = updated_name;
    setProjectColors(tempColors);
  };

  const addNewColor = () => {
    const newColor = projectColors
      ? [...(projectColors ? projectColors : [])]
      : [];
    newColor.push({
      title: `color-${projectColors ? projectColors.length + 1 : 1}`,
      color: "#fff",
    });
    setNewAdded(true);
    setProjectColors(newColor);
  };

  const handleColorDelete = (index) => {
    const newObj = [...projectColors];
    newObj.splice(index, 1);
    setProjectColors(newObj);
  };

  const updateColors = (e) => {
    e.preventDefault();

    updateProjectColors(projectColors, project?.colorVariants)
      .then(() => {
        // setOpen(false);
      })
      .catch((err) => {
        // console.log(err);
      });
  };

  const addNewPalette = () => {
    const newPalette = JSON.parse(
      JSON.stringify(
        projectColors ? [...(projectColors ? projectColors : [])] : [],
      ),
    );
    setProjectData({
      ...project,
      colorVariants: [
        ...(project?.colorVariants ? project?.colorVariants : []),
        {
          colors: newPalette,
        },
      ],
    });
  };

  return (
    <>
      <div className="color-palette-container   flex flex-col gap-3 p-4 overflow-x-hidden h-full overflow-y-auto">
        <div className="flex flex-col gap-3">
          <p className="text-grigora-base">Current Color Palette</p>
          <div className="flex gap-2 flex-wrap">
            {projectColors &&
              Array.isArray(projectColors) &&
              projectColors?.map((colorItem, i) => {
                return (
                  <RenderColor
                    key={`settings-color-${i}`}
                    index={i}
                    onDelete={() => {
                      handleColorDelete(i);
                    }}
                    color={colorItem.color}
                    onChange={(val, index) => {
                      var tempColors = [...projectColors];
                      tempColors[i].color = val;
                      setProjectColors(tempColors);
                    }}
                    colorName={colorItem.title}
                    onColorNameChange={(val) => {
                      changeColorName(i, val);
                    }}
                    newAdded={newAdded}
                  />
                );
              })}
            <Tooltip text="Add New Color" placement="top">
              <div
                onClick={() => addNewColor()}
                className="w-8 h-8 cursor-pointer flex items-center justify-center"
              >
                <FontAwesomeIcon icon={faPlus} />
              </div>
            </Tooltip>
            <Tooltip text="Create Palette" placement="top">
              <div
                onClick={() => addNewPalette()}
                className="w-8 h-8 cursor-pointer flex items-center justify-center"
              >
                <FontAwesomeIcon icon={faPalette} />
              </div>
            </Tooltip>
          </div>
          <div className="flex flex-col gap-1">
            <p className="text-grigora-base">Other Variants</p>
            <p className="text-grigora-base italic text-gray-500">
              Variants are different color palette which you can switch
              instantly.
            </p>
          </div>
          {project?.colorVariants && Array.isArray(project?.colorVariants) ? (
            project?.colorVariants.map((variant, i) => {
              return (
                <div
                  key={`color-variant-${i}`}
                  className="flex flex-col gap-3 px-2 py-2 rounded-[5px] cursor-pointer hover:border-gray-300 border border-white duration-300 justify-center "
                >
                  <div className="flex gap-2 flex-wrap">
                    {variant?.colors?.map((colorItem, j) => {
                      return (
                        <RenderColor
                          key={`settings-color-variant-${i}-color-${j}`}
                          index={i}
                          onDelete={() => {
                            var updatedVariant = { ...variant };

                            updatedVariant = {
                              ...updatedVariant,
                              colors: [
                                ...updatedVariant.colors?.filter(
                                  (item, index) => index !== j,
                                ),
                              ],
                            };

                            setProjectData({
                              ...project,
                              colorVariants: [
                                ...project.colorVariants.map(
                                  (variant, index) => {
                                    if (index === i) {
                                      return updatedVariant;
                                    }
                                    return variant;
                                  },
                                ),
                              ],
                            });
                          }}
                          color={colorItem.color}
                          onChange={(val, index) => {
                            var updatedVariant = { ...variant };

                            updatedVariant = {
                              ...updatedVariant,
                              colors: [
                                ...updatedVariant.colors?.map((item, index) => {
                                  if (index === j) {
                                    return {
                                      ...item,
                                      color: val,
                                    };
                                  }
                                  return item;
                                }),
                              ],
                            };

                            setProjectData({
                              ...project,
                              colorVariants: [
                                ...project.colorVariants.map(
                                  (variant, index) => {
                                    if (index === i) {
                                      return updatedVariant;
                                    }
                                    return variant;
                                  },
                                ),
                              ],
                            });
                          }}
                          colorName={colorItem.title}
                          onColorNameChange={(val) => {
                            var updatedVariant = { ...variant };

                            updatedVariant = {
                              ...updatedVariant,
                              colors: [
                                ...updatedVariant.colors?.map((item, index) => {
                                  if (index === j) {
                                    return {
                                      ...item,
                                      title: val,
                                    };
                                  }
                                  return item;
                                }),
                              ],
                            };

                            setProjectData({
                              ...project,
                              colorVariants: [
                                ...project.colorVariants.map(
                                  (variant, index) => {
                                    if (index === i) {
                                      return updatedVariant;
                                    }
                                    return variant;
                                  },
                                ),
                              ],
                            });
                          }}
                          newAdded={newAdded}
                        />
                      );
                    })}
                    <Tooltip text={`Add New Color`} placement="top">
                      <div
                        onClick={() => {
                          // Add new color to palette

                          var updatedVariant = { ...variant };

                          updatedVariant = {
                            ...updatedVariant,
                            colors: [
                              ...updatedVariant.colors,
                              {
                                title: `color-${
                                  updatedVariant.colors
                                    ? updatedVariant.colors.length + 1
                                    : 1
                                }`,
                                color: "#fff",
                              },
                            ],
                          };

                          setProjectData({
                            ...project,
                            colorVariants: [
                              ...project.colorVariants.map((variant, index) => {
                                if (index === i) {
                                  return updatedVariant;
                                }
                                return variant;
                              }),
                            ],
                          });
                        }}
                        className="w-8 h-8 cursor-pointer flex items-center justify-center"
                      >
                        <FontAwesomeIcon icon={faPlus} />
                      </div>
                    </Tooltip>
                    <Tooltip text={`Use This Variant`} placement="top">
                      <div
                        onClick={() => {
                          setProjectColors([
                            ...(variant.colors ? variant.colors : []),
                          ]);
                        }}
                        className="w-8 h-8 cursor-pointer flex items-center justify-center"
                      >
                        <FontAwesomeIcon icon={faUpload} />
                      </div>
                    </Tooltip>
                    <Tooltip text={`Delete`} placement="top">
                      <div
                        onClick={() => {
                          setProjectData({
                            ...project,
                            colorVariants: [
                              ...project?.colorVariants?.filter(
                                (item, index) => index !== i,
                              ),
                            ],
                          });
                        }}
                        className="w-8 h-8 cursor-pointer flex items-center justify-center"
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </div>
                    </Tooltip>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="text-grigora-base text-gray-500">
              No Variants Found
            </div>
          )}
        </div>
        <div className="flex justify-start">
          <button onClick={updateColors} className="grigora-action-btn">
            Update
          </button>
        </div>
      </div>
    </>
  );
}

export default SettingsColor;
